/**
 * Applies this session's adds and removes on top of the latest saved list, so
 * an edit another admin saved while the modal was open isn't overwritten.
 */
export const applyIncludedChanges = (
  latest: string[],
  added: string[],
  removed: string[]
): string[] => {
  const removedSet = new Set(removed);
  const result = latest.filter((code) => !removedSet.has(code));
  added.forEach((code) => {
    if (!result.includes(code)) result.push(code);
  });
  return result;
};
